// @flow
import type { BetTicketState } from "@fdr/types/Bet";

type SetBetTicketStateAction = {
  type: "SET_BET_TICKET_STATE",
  payload: BetTicketState
};

export const setBetTicketState = (
  value: BetTicketState
): SetBetTicketStateAction => ({
  type: "SET_BET_TICKET_STATE",
  payload: value
});

export default setBetTicketState;
